import React from 'react';
import { Animation } from '../../animation/animation';

import styles from './header.module.scss';
import Logo from '../logo/logo';
import Descriptor from '../descriptor/descriptor';
import Phone from '../phone/phone';
import { useMediaQuery } from 'react-responsive';

interface HeaderProps {
	active: boolean
	data: HeaderData
	children: React.ReactNode
}

export interface HeaderData {
	logo?: string
	descriptor?: string
	phone?: string
	link?: string
}

export default function Header(props:HeaderProps) {
	const { active, data: { logo, descriptor, phone, link }, children} = props;
	const fromMobile:boolean = useMediaQuery({ maxWidth: 900 });

	return (
		<header 
			className={styles.header}
		>
			<Animation name={fromMobile ? 'fade' : 'slide'} left={!fromMobile} up={fromMobile} duration={fromMobile ? 300 : 1000} delay={100} when={active}>
				{logo && <Logo link={link} src={logo}/>}
				{descriptor && <Descriptor value={descriptor}/>}
			</Animation>
			{phone &&
				<Animation name={fromMobile ? 'fade' : 'slide'} right={!fromMobile} up={fromMobile} duration={fromMobile ? 300 : 1000} when={active}>
					<Phone phone={phone || '+7 (988) 962-83-45'}/>
				</Animation>
			}
			{children && 
				<Animation name={fromMobile ? 'fade' : 'slide'} right={!fromMobile} up={fromMobile} duration={fromMobile ? 300 : 1000} when={active}>
					{children}
				</Animation>
			}
		</header>
	);
}